const FREE_SHIPPING_REGIONS = {
  GB: 'UK',
  GG: 'UK',
  IM: 'UK',
  JE: 'UK',
  US: 'US',
  AU: 'AUS',
  FR: 'EU', DE: 'EU', IT: 'EU', ES: 'EU', NL: 'EU', BE: 'EU', AT: 'EU',
  IE: 'EU', PT: 'EU', GR: 'EU', FI: 'EU', SE: 'EU', DK: 'EU', PL: 'EU',
  CZ: 'EU', HU: 'EU', RO: 'EU', BG: 'EU', HR: 'EU', SI: 'EU', SK: 'EU',
  EE: 'EU', LV: 'EU', LT: 'EU', CY: 'EU', MT: 'EU', LU: 'EU',
};

class CartFreeShipping extends HTMLElement {
  connectedCallback() {
    this.cartTotal = parseInt(this.getAttribute('cart-total'), 10) || 0;

    this.thresholdAmounts = {
      UK: parseInt(this.dataset.thresholdUk, 10) || 0,
      US: parseInt(this.dataset.thresholdUs, 10) || 0,
      EU: parseInt(this.dataset.thresholdEu, 10) || 0,
      AUS: parseInt(this.dataset.thresholdAus, 10) || 0,
      ROW: parseInt(this.dataset.thresholdRow, 10) || 0,
    };

    this.userCountry = this.getUserLocation();

    if (this.userCountry === 'ROW') {
      this.innerHTML = '';
      return;
    }

    this.thresholdAmount = this.thresholdAmounts[this.userCountry] || this.thresholdAmounts.ROW;

    if (!this.thresholdAmount || this.cartTotal <= 0) {
      this.innerHTML = '';
      return;
    }

    this.thresholdAmountFormatted = this.formatMoney(this.thresholdAmount - this.cartTotal);
    this.percentage = Math.min((this.cartTotal / this.thresholdAmount) * 100, 100);

    this.render();
  }

  getUserLocation() {
    const country = (window.Shopify && window.Shopify.country) || 'ROW';
    return FREE_SHIPPING_REGIONS[country] || 'ROW';
  }

  formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents).replace(/\s/g, '');
    }
    return (cents / 100).toFixed(2);
  }

  // Setting values may still contain the legacy `${this.thresholdAmountFormatted}`
  // token from when this file was Liquid-rendered. Support both it and `{{amount}}`.
  interpolate(value) {
    return String(value || '')
      .replace(/\$\{\s*this\.thresholdAmountFormatted\s*\}/g, this.thresholdAmountFormatted)
      .replace(/\{\{\s*amount\s*\}\}/g, this.thresholdAmountFormatted);
  }

  render() {
    const reached = this.cartTotal >= this.thresholdAmount;

    const title = this.interpolate(reached ? this.dataset.reachedTitle : this.dataset.notReachedTitle);
    const message = this.interpolate(reached ? this.dataset.reachedMessage : this.dataset.notReachedMessage);

    let html = '';
    html += `<p class="free-shipping-notification__title">${title}</p>`;
    html += `<p class="free-shipping-notification__message">${message}</p>`;

    if (!reached) {
      html += '<div class="free-shipping-notification__threshold">';
      html += `<div class="free-shipping-notification__threshold__bar" style="width: ${this.percentage}%"></div>`;
      html += '</div>';
    }

    this.innerHTML = html;
  }
}

if (!customElements.get('free-shipping-notification')) {
  customElements.define('free-shipping-notification', CartFreeShipping);
}